import React, { useState } from 'react'
import { Form, Button, Modal } from 'react-bootstrap'
import { useUpdateIssueLog } from 'api/hooks/use-issue-logs'
import Datetime from 'react-datetime'
import { useQueryClient } from 'react-query'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeMute } from '@fortawesome/free-solid-svg-icons'

function IgnoreForm({ issueLogId, open, setOpen }) {
  const queryClient = useQueryClient()
  const [ignoreType, setIgnoreType] = useState('')
  const [ignoreComments, setIgnoreComments] = useState('')
  const [ignoreExpirationUntil, setIgnoreExpirationUntil] = useState('')
  const [ignoreAt, setIgnoreAt] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    mutate()
    setOpen(false)
    resetForm()
  }

  const resetForm = () => {
    setIgnoreType('')
    setIgnoreComments('')
    setIgnoreExpirationUntil('')
    setIgnoreAt('')
  }

  const { mutate } = useUpdateIssueLog({
    params: {
      id: issueLogId,
      ignore_type: ignoreType,
      ignore_comments: ignoreComments,
      ignore_expiration_until: ignoreExpirationUntil,
      ignore_at: ignoreAt,
      status: 'ignored'
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(['issue-logs'])
      }
    }
  })

  const isFormValid = () => {
    return ignoreType && ignoreComments && ignoreExpirationUntil && ignoreAt
  }

  return (
    <>
      <Button variant="light" size="sm" onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faVolumeMute} className="me-1" />
        Ignore
      </Button>
      <Modal show={open} onHide={() => setOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ignore Issue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <div className="mt-3">
              <Form.Group controlId="ignoreType">
                <Form.Label>Ignore Type</Form.Label>
                <Form.Control
                  as="select"
                  value={ignoreType}
                  onChange={(e) => setIgnoreType(e.target.value)}
                >
                  <option value="">Select...</option>
                  <option value="not_an_issue">Not an Issue</option>
                  <option value="temporary">Temporary</option>
                  <option value="wont_fix">Won't Fix</option>
                </Form.Control>
              </Form.Group>
            </div>

            <div className="mt-3">
              <Form.Group controlId="ignoreComments">
                <Form.Label>Ignore Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={ignoreComments}
                  onChange={(e) => setIgnoreComments(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="mt-3">
              <Form.Group controlId="ignoreExpirationUntil">
                <Form.Label>Ignore Expiration Until</Form.Label>
                <Datetime
                  dateFormat={'YYYY-MM-DD'}
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnTab={true}
                  isValidDate={(current) => current.isAfter(new Date())}
                  input={true}
                  placeholderText="Start Date"
                  onChange={(value) =>
                    setIgnoreExpirationUntil(
                      value?.isValid() ? value.format('YYYY-MM-DD') : ''
                    )
                  }
                  value={ignoreExpirationUntil}
                />
              </Form.Group>
            </div>

            <div className="mt-3">
              <Button variant="primary" disabled={isFormValid()} type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default IgnoreForm
